import { render, staticRenderFns } from "./OneCompany.vue?vue&type=template&id=08b29bb9&"
import script from "./OneCompany.vue?vue&type=script&lang=js&"
export * from "./OneCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('08b29bb9', component.options)
    } else {
      api.reload('08b29bb9', component.options)
    }
    module.hot.accept("./OneCompany.vue?vue&type=template&id=08b29bb9&", function () {
      api.rerender('08b29bb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Pages/OneCompany.vue"
export default component.exports